import { useAdminPendingReportCount, useAdminReportQueue } from './useAdminReports'
import type { SetReport } from '../types'

export { needsAdmin } from './useAdminReports'

export function useAdminSetReports() {
  return useAdminReportQueue<SetReport>('setReports')
}

export function useAdminPendingSetReportCount(): number {
  return useAdminPendingReportCount('setReports')
}
